var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.868 1.132A1 1 0 0 1 21.1 2.18l-6.5 18-.032.077a1.55 1.55 0 0 1-2.809.02l-3.345-6.691-6.69-3.345a1.55 1.55 0 0 1 .096-2.841l18-6.5a1 1 0 0 1 1.047.233m-10.49 11.905 2.714 5.43 4.605-12.75zm5.905-8.734L3.532 8.907l5.431 2.716z",
    clipRule: "evenodd"
  })));
};
export default SvgSend;